import { IMember } from "../../../screens/AccountMembership/_private/types/midView";
import { fetchAtClientSide } from "utils/misc/fetchClient";

export const firebaseRegister =  (token) => {
  let url = `firebases/register`;
  return fetchAtClientSide({
    url,
    body: {
      GulpinRegister: { token: decodeURIComponent(token), channel: "firebase" },
    },
    method: "POST",
  });
};
